import Vue from 'vue'
import VuejsDialog from 'vuejs-dialog'

import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import ContractCancelDialog from '@/components/crud/contract/partials/ContractCancelDialog';
import ContractSignOffDialog from '@/components/crud/contract/partials/ContractSignOffDialog';
import SimpleDialog from '@/components/common/dialog/SimpleDialog';
import ContractEditOrderNumberDialog from "@/components/crud/contract/partials/ContractEditOrderNumberDialog";

export default () => {
  const options = {
    html: true,
    okText: 'Ok',
    cancelText: 'Annuleren',
    customClass: 'vue-dialog',
  }

  Vue.use(VuejsDialog, options)

  Vue.dialog.registerComponent('contract-sign-off-dialog', ContractSignOffDialog);
  Vue.dialog.registerComponent('contract-cancel-dialog', ContractCancelDialog);
  Vue.dialog.registerComponent('contract-edit-order-number-dialog', ContractEditOrderNumberDialog);
  Vue.dialog.registerComponent('simple-dialog', SimpleDialog);
}
